import { connectionTypes } from "./connection.types";

export const setIsReconnecting = (isReconnecting) => ({
  type: connectionTypes.SET_IS_RECONNECTING,
  payload: isReconnecting,
});

export const setIsConnected = (isConnected) => ({
  type: connectionTypes.SET_IS_CONNECTED,
  payload: isConnected,
});
